import { UserCertificate, UserProfile } from 'app/models';
import { CertificateType, certificateTypes } from './form.constants';

type CertificateWithPreview = UserCertificate & {
	preview: string;
};

type UploadedCertificates = { [type in CertificateType]: [] };

const profileCertificatesReducer = (
	acc: { [type in CertificateType]: CertificateWithPreview[] },
	certificate: UserCertificate,
) => {
	const newCertificateItem: CertificateWithPreview = {
		...certificate,
		preview: certificate.document,
	};

	return acc[certificate.kind as CertificateType]
		? {
				...acc,
				[certificate.kind]: [...acc[certificate.kind as CertificateType], newCertificateItem],
		  }
		: {
				...acc,
				[certificate.kind]: [newCertificateItem],
		  };
};

const certificatesDefaultState: UploadedCertificates = certificateTypes.reduce((acc, item) => {
	return {
		...acc,
		[item]: [],
	};
}, {} as UploadedCertificates);

export const mapProfileCertificates = (certificates: UserProfile['certificates'] = {}) => {
	if (!certificates || !Object.values(certificates).length) {
		return {} as UploadedCertificates;
	}

	const result = Object.values(certificates).reduce(profileCertificatesReducer, certificatesDefaultState);

	return result;
};
